const validatorFields = {
	password: {
		required: true,
		errorLocation: 'below',
		pattern: (sample, $field) => {
			if (sample.length === 0) {
				return false;
			}
			if (sample.length < 5) {
				$field.trigger('validation-error-index', [1]);
				return false;
			}
			return true;
		},
		when: 'submit'
	},
	username: {
		required: true,
		errorLocation: 'below',
		pattern: (sample, $field) => {
			if (sample.length === 0) {
				return false;
			}
			if (sample.length < 4) {
				$field.trigger('validation-error-index', [1]);
				return false;
			}
			if (!/^[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÄËÏÖÜçÇßøØåÅæÆþÞðÐ\d\s'.,-@_+]{4,64}$/.test(sample)) {
				$field.trigger('validation-error-index', [2]);
				return false;
			}
			return true;
		},
		when: 'submit'
	}
};

export default validatorFields;



// WEBPACK FOOTER //
// ./app/public/src/js/signin/frame/index/validation/validatorFields.js